<template>
	<ui-modal :name="$mx_getModalName" title="Selecionar cliente" icon="fal fa-user-circle">
		<template>
			<section class="search-customer">
				<ui-input v-model="search" placeholder="Buscar cliente" />
			</section>
			<section class="wrapper-list">
				<ui-customers-wrapper-list v-model="customersDuplicityFoundComputed" />
				<section class="warning">
					<div>Este(s) fora(m) o(s) cliente(s) encontrado(s) com dados similares.</div>
					<div>
						Se você achou que o cliente a ser cadastrado já existe, você pode
						seleciona-lo e então prosseguir.
					</div>
				</section>
			</section>
		</template>
		<template #footer>
			<ui-modal-cancel-button :modalName="$mx_getModalName" design="link-alt">
				Cancelar
			</ui-modal-cancel-button>
			<ui-button
				type="button"
				design="md success"
				:disabled="!canConfirm"
				@click="overrideCustomer"
			>
				Confirmar
			</ui-button>
		</template>
	</ui-modal>
</template>

<script>
	import { uiModal, uiModalCancelButton } from '@/components/ui/modal'
	import { uiCustomersWrapperList } from '@/components/ui-facilita/wrapper'
	import { uiInput } from '@/components/ui/form'
	import { uiButton } from '@/components/ui/buttons'

	import { modalMixin } from '@/mixins'

	export default {
		name: 'ui-override-customer-modal',

		components: {
			uiModal,
			uiModalCancelButton,
			uiCustomersWrapperList,
			uiInput,
			uiButton,
		},

		mixins: [modalMixin],

		props: {
			name: {
				type: String,
				required: true,
			},
		},

		data() {
			return {
				customersDuplicityFound: [],
				search: '',
			}
		},

		computed: {
			customerSelected() {
				return this.customersDuplicityFoundComputed.find((customer) => customer.checked)
			},

			canConfirm() {
				return this.customerSelected ? true : false
			},

			customersDuplicityFoundComputed: {
				get() {
					if (!this.search || this.search == '') return this.customersDuplicityFound

					const byName = this.filterCustomers(this.customersDuplicityFound, 'name')
					const byEmail = this.filterCustomers(this.customersDuplicityFound, 'email')
					const byMobile = this.filterCustomers(this.customersDuplicityFound, 'mobile')
					const byPhone = this.filterCustomers(this.customersDuplicityFound, 'phone')
					const byCPF = this.filterCustomers(this.customersDuplicityFound, 'cpf')
					const byCNPJ = this.filterCustomers(this.customersDuplicityFound, 'cnpj')

					if (byName.length > 0) return byName
					if (byEmail.length > 0) return byEmail
					if (byMobile.length > 0) return byMobile
					if (byPhone.length > 0) return byPhone
					if (byCPF.length > 0) return byCPF
					if (byCNPJ.length > 0) return byCNPJ

					return []
				},
				set(newVal) {
					return newVal
				},
			},
		},

		methods: {
			overrideCustomer() {
				this.$root.$emit('create-deal-override-customer', this.customerSelected)
				this.$mx_closeModal()
			},

			filterCustomers(data, type) {
				return data.filter((item) => {
					if (item[type] && item[type] != '')
						return item[type].toLowerCase().includes(this.search.toLowerCase())

					return []
				})
			},
		},

		mounted() {
			this.$root.$on('modal-open-' + this.$mx_getModalName, (data) => {
				this.customersDuplicityFound = data
			})

			this.$root.$on('clean--' + this.$mx_getModalName, () => {
				this.customersDuplicityFound = []
			})
		},

		beforeDestroy() {
			this.$root.$off('modal-open-' + this.$mx_getModalName)
			this.$root.$off('clean--' + this.$mx_getModalName)
		},
	}
</script>

<style lang="stylus" scoped>
	@import './styles.styl'
</style>
